// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { SortDirection, invert } from '@/constants/sort';
import { useState } from 'react';

/**
 * A React hook that manages the sorting state for a collection of data.
 *
 * @param initialProperty - The initial property by which to sort the data.
 * @param initialDirection - The initial direction by which to sort the data.
 */
export function useSort<SortProperty>(
  initialProperty: SortProperty,
  initialDirection: SortDirection = 'asc'
) {
  const [property, setProperty] = useState<SortProperty>(initialProperty);
  const [direction, setDirection] = useState<SortDirection>(initialDirection);

  const setSort = (
    newProperty: SortProperty,
    newDirection: SortDirection = 'asc'
  ) => {
    if (newProperty === property) {
      setDirection(invert);

      return;
    }

    setProperty(newProperty);
    setDirection(newDirection);
  };

  return { setSort, sort: { property, direction } };
}
